var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PackingListTable',{attrs:{"shipmentCode":_vm.shipmentCode,"shipmentStatus":_vm.shipmentStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }